import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock, openBlock, renderSlot } from "vue";
//#region src/components/ViewLayout/ViewLayoutContent.vue
var _sfc_main = {};
var _hoisted_1 = { class: "custom-scroll flex flex-col pr-0 *:border-t *:first:border-t-0 xl:flex-row *:xl:border-t-0 *:xl:border-l *:first:xl:border-l-0" };
function _sfc_render(_ctx, _cache) {
	return openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "default")]);
}
var ViewLayoutContent_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render]]);
//#endregion
export { ViewLayoutContent_default as default };

//# sourceMappingURL=ViewLayoutContent.vue.js.map